module.exports = __webpack_public_path__ + "img/heart@3x.f3384d9a.png";